/* ============================================================
   SOLIA v7 — page sections
   Homepage final compact pass: copy-compliant hero, updated ticker,
   compact side-by-side product cards ABOVE support pillars,
   hidden story/reviews, mobile hero/anatomy/footer refinements.
   ============================================================ */
/* Standalone-prototype asset shim. In Shopify, the section's Liquid
   defines window.SOLIA_ASSETS first, so this no-ops there. */
window.SOLIA_ASSETS = window.SOLIA_ASSETS || {
    stickCl: 'solia-v7/assets/stick-cl.png',
    stickPog: 'solia-v7/assets/stick-pog.png',
    bagCl: 'solia-v7/assets/bag-cl.png',
    bagPog: 'solia-v7/assets/bag-pog.png',
    anatomy: 'solia-v7/assets/anatomy.png',
};
/* ============================================================
   HOMEPAGE-ONLY STYLE PATCH
   Kept here so you do not need to touch solia.css for this pass.
   ============================================================ */
function HomepageStylePatch() {
    return (React.createElement("style", null, `
      /* ----- hero support tags ----- */
      .hero-support-heading {
        margin-top: 34px;
        margin-bottom: 14px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: var(--blue-deep);
      }

      .hero-support-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px 12px;
        max-width: 650px;
      }

      .hero-support-tag {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 11px 13px;
        border: 1px solid var(--black-12);
        border-radius: 16px;
        background: rgba(253,254,241,0.72);
        color: var(--black-70);
        font-size: 13px;
        line-height: 1.35;
        font-weight: 400;
      }

      .hero-support-tag strong {
        color: var(--black);
        font-weight: 600;
      }

      .hero-support-tag .hero-check-icon {
        width: 18px;
        height: 18px;
        margin-top: 1px;
      }

      /* ----- hero product animation stability ----- */
      .hero-stick {
        will-change: transform;
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        contain: layout paint;
      }

      .hero-stick img {
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transform: translateZ(0);
      }


      /* Compositor-friendly hero motion. The original floating treatment and
         scroll-linked drift are preserved without React state updates. */
      .hero-stick-cl {
        --solia-scroll-y: 0px;
        animation: solia-float-cl 6.4s ease-in-out infinite;
      }

      .hero-stick-pog {
        --solia-scroll-y: 0px;
        animation: solia-float-pog 6.8s ease-in-out infinite;
      }

      @keyframes solia-float-cl {
        0%, 100% { transform: translate(-92%, -50%) translateY(var(--solia-scroll-y)) rotate(-7deg); }
        50% { transform: translate(-92%, -50%) translateY(calc(var(--solia-scroll-y) + 10px)) rotate(-5.5deg); }
      }

      @keyframes solia-float-pog {
        0%, 100% { transform: translate(-8%, -50%) translateY(var(--solia-scroll-y)) rotate(7deg); }
        50% { transform: translate(-8%, -50%) translateY(calc(var(--solia-scroll-y) - 11px)) rotate(8.4deg); }
      }

      @media (prefers-reduced-motion: reduce) {
        .hero-stick-cl,
        .hero-stick-pog { animation: none !important; }
      }

      /* ----- banner dot alignment ----- */
      .solia-home-marquee-track {
        align-items: center !important;
        gap: 24px !important;
      }

      .solia-home-marquee-item {
        gap: 0 !important;
      }

      .solia-home-marquee-dot {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 8px !important;
        font-size: 8px !important;
        opacity: 0.35 !important;
        color: var(--black) !important;
        line-height: 1 !important;
        flex: 0 0 auto !important;
      }

      /* ----- compact product chooser ----- */
      .home-products {
        background:
          radial-gradient(circle at 18% 16%, rgba(253,254,241,0.64), transparent 30%),
          linear-gradient(180deg, var(--blue-section) 0%, var(--blue-section) 100%);
        padding: clamp(34px, 5vw, 58px) clamp(18px, 5vw, 64px) clamp(38px, 5vw, 62px);
        position: relative;
        overflow: hidden;
      }

      .home-products .container {
        max-width: 1180px;
      }

      .home-products-head {
        text-align: center;
        max-width: 700px;
        margin: 0 auto 28px;
      }

      .home-products-head .body-md {
        max-width: 520px;
        margin: 16px auto 0;
      }

      .product-compare-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 18px;
        align-items: stretch;
      }

      .product-compare-card {
        position: relative;
        overflow: hidden;
        border: 1px solid rgba(14,14,12,0.10);
        border-radius: 22px;
        background: rgba(253,254,241,0.82);
        box-shadow: 0 24px 60px -44px rgba(14,14,12,0.25);
        min-height: 455px;
        display: flex;
        flex-direction: column;
      }

      .product-compare-card::before {
        content: "";
        display: block;
        height: 6px;
        width: 100%;
        background: var(--accent-bar, rgba(253,254,241,0.86));
      }

      .product-compare-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 16px 22px;
        border-bottom: 1px solid rgba(14,14,12,0.08);
      }

      .product-compare-pill {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        padding: 7px 14px;
        border-radius: 100px;
        border: 1px solid rgba(14,14,12,0.10);
        background: rgba(253,254,241,0.72);
        color: var(--black);
        font-family: var(--sans);
        font-size: 10.5px;
        font-weight: 700;
        letter-spacing: 1.9px;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .product-compare-pill .dot {
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: var(--accent, var(--blue));
        box-shadow: inset 0 0 0 1px rgba(14,14,12,0.08);
      }

      .product-compare-meta {
        color: var(--black-40);
        font-family: var(--sans);
        font-size: 10.5px;
        font-weight: 600;
        letter-spacing: 1.7px;
        text-transform: uppercase;
        white-space: nowrap;
      }

      .product-compare-body {
        flex: 1;
        display: grid;
        grid-template-columns: 0.9fr 1fr;
        align-items: center;
        gap: 12px;
        padding: 22px 26px 28px;
      }

      .product-compare-image {
        position: relative;
        min-height: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
      }

      .product-compare-image::before {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: 92%;
        aspect-ratio: 1 / 1;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        background: radial-gradient(circle, rgba(253,254,241,0.78) 0%, rgba(253,254,241,0.36) 48%, transparent 72%);
        pointer-events: none;
      }

      .product-compare-image img {
        position: relative;
        z-index: 1;
        width: min(92%, 270px);
        max-height: 255px;
        object-fit: contain;
        filter: drop-shadow(0 28px 44px rgba(74,142,160,0.17));
      }

      .product-compare-copy {
        text-align: left;
      }

      .product-compare-copy h3 {
        margin: 0 0 12px;
        font-family: var(--sans);
        font-size: clamp(32px, 3.1vw, 44px);
        line-height: 1.02;
        letter-spacing: -1.5px;
        font-weight: 600;
        color: var(--black);
      }

      .product-compare-copy p {
        max-width: 360px;
        margin: 0;
        color: var(--black-60);
        font-family: var(--sans);
        font-size: 15px;
        line-height: 1.62;
        font-weight: 300;
      }

      .product-compare-facts {
        margin: 18px 0 0;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
        max-width: 315px;
      }

      .product-compare-fact {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 10px;
        padding: 9px 13px;
        border-radius: 100px;
        border: 1px solid rgba(14,14,12,0.10);
        background: rgba(240,242,230,0.62);
        color: var(--black-70);
        font-family: var(--sans);
        font-size: 13px;
        line-height: 1.25;
      }

      .product-compare-fact svg {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        color: var(--blue-deep);
      }

      .product-compare-copy .btn {
        margin-top: 20px;
        justify-content: center;
        min-width: 0;
        padding: 13px 22px;
      }

      .product-support-line {
        text-align: center;
        margin: 22px auto 0;
        color: var(--black-60);
        font-family: var(--sans);
        font-size: 13px;
        letter-spacing: 0.2px;
      }

      /* ----- compact six pillars ----- */
      .home-pillars-compact {
        padding-top: 44px !important;
        padding-bottom: 52px !important;
      }

      .home-pillars-compact .anatomy-head {
        margin-bottom: 18px !important;
      }

      .home-pillars-compact .anatomy-head .h2 {
        margin-bottom: 16px !important;
      }

      .home-pillars-compact .anatomy-grid {
        margin-top: 18px !important;
        min-height: 360px !important;
      }

      .home-pillars-compact .anatomy-figure {
        min-height: 360px !important;
      }

      .home-pillars-compact .anatomy-figure-inner {
        max-width: 360px !important;
      }

      .reviews-disabled {
        display: none !important;
      }

      @media (max-width: 1120px) {
        .product-compare-body {
          grid-template-columns: 1fr;
          text-align: center;
          padding: 24px 24px 30px;
        }

        .product-compare-copy {
          text-align: center;
        }

        .product-compare-copy p,
        .product-compare-facts {
          margin-left: auto;
          margin-right: auto;
        }
      }

      @media (max-width: 768px) {
        .hero-text {
          text-align: left !important;
          align-items: flex-start !important;
        }

        .hero-text .eyebrow,
        .hero-text .h1,
        .hero-text .body-lg {
          text-align: left !important;
          width: 100% !important;
        }

        .hero-text .body-lg {
          max-width: 100% !important;
          font-size: 16px !important;
          line-height: 1.58 !important;
          letter-spacing: -0.1px !important;
          margin-top: 22px !important;
        }

        .hero-support-heading {
          width: 100%;
          text-align: left;
          margin-top: 30px;
        }

        .hero-support-grid {
          width: 100%;
          grid-template-columns: 1fr;
          gap: 10px;
          max-width: 360px;
          align-self: stretch;
        }

        .hero-support-tag {
          text-align: left;
          justify-content: flex-start;
          padding: 12px 14px;
          font-size: 13px;
          background: rgba(253,254,241,0.82);
        }

        .home-products {
          padding: 38px 16px 44px;
        }

        .home-products-head {
          margin-bottom: 22px;
          text-align: left;
        }

        .home-products-head .h2,
        .home-products-head .body-md,
        .home-products-head .eyebrow {
          text-align: left;
        }

        .home-products-head .h2 {
          font-size: clamp(34px, 9vw, 44px);
          letter-spacing: -1.5px;
        }

        .product-compare-grid {
          grid-template-columns: 1fr;
          gap: 16px;
        }

        .product-compare-card {
          border-radius: 22px;
          min-height: auto;
        }

        .product-compare-top {
          padding: 13px 15px;
          gap: 8px;
        }

        .product-compare-pill {
          font-size: 10px;
          letter-spacing: 1.5px;
          padding: 7px 12px;
          max-width: 68%;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-compare-meta {
          font-size: 10px;
          letter-spacing: 1.35px;
        }

        .product-compare-body {
          display: grid;
          grid-template-columns: 0.72fr 1fr;
          gap: 8px;
          padding: 18px 16px 22px;
          align-items: center;
          text-align: left;
        }

        .product-compare-image {
          min-height: 170px;
          padding: 0;
        }

        .product-compare-image img {
          width: min(100%, 175px);
          max-height: 180px;
        }

        .product-compare-copy {
          text-align: left;
        }

        .product-compare-copy h3 {
          font-size: clamp(27px, 7.4vw, 38px);
          letter-spacing: -1.2px;
          margin-bottom: 10px;
        }

        .product-compare-copy p {
          font-size: 14px;
          line-height: 1.52;
          max-width: none;
          margin: 0;
        }

        .product-compare-facts {
          display: none;
        }

        .product-compare-copy .btn {
          width: 100%;
          max-width: 260px;
          min-width: 0;
          margin-top: 16px;
          padding: 12px 18px;
          font-size: 13px;
        }

        .product-support-line {
          max-width: 320px;
          font-size: 13px;
          line-height: 1.6;
        }

        .home-pillars-compact {
          padding-top: 26px !important;
          padding-bottom: 34px !important;
          scroll-margin-top: 92px !important;
        }

        .home-pillars-compact .anatomy-head {
          margin-bottom: 4px !important;
          max-width: 340px !important;
        }

        .home-pillars-compact .anatomy-head .eyebrow {
          margin-bottom: 12px !important;
        }

        .home-pillars-compact .anatomy-head .h2 {
          font-size: clamp(34px, 9vw, 44px) !important;
          line-height: 1.04 !important;
          letter-spacing: -1.5px !important;
          margin-bottom: 14px !important;
        }

        .home-pillars-compact .anatomy-head .body-md {
          font-size: 15px !important;
          line-height: 1.55 !important;
          max-width: 330px !important;
        }

        .home-pillars-compact .anatomy-grid {
          margin-top: 0 !important;
          gap: 10px !important;
        }

        .home-pillars-compact .anatomy-figure {
          min-height: 285px !important;
          margin: 4px 0 8px !important;
        }

        .home-pillars-compact .anatomy-figure-inner {
          max-width: 360px !important;
          width: min(92vw, 360px) !important;
        }

        .home-pillars-compact .anatomy-list {
          gap: 8px !important;
        }

        .home-pillars-compact .anatomy-item {
          padding: 14px 16px !important;
          border-radius: 14px !important;
        }

        .home-pillars-compact .anatomy-name {
          font-size: 20px !important;
          line-height: 1.16 !important;
        }

        .home-pillars-compact .anatomy-sub {
          font-size: 13px !important;
          line-height: 1.35 !important;
        }

        .home-pillars-compact .rev.d2 {
          margin-top: 14px !important;
        }

        /* tighter footer link spacing on homepage mobile */
        .footer {
          padding-top: 54px !important;
        }

        .footer-grid {
          gap: 24px !important;
          margin-bottom: 34px !important;
        }

        .footer h4 {
          margin-bottom: 10px !important;
        }

        .footer a {
          padding: 2px 0 !important;
          line-height: 1.35 !important;
        }

        .footer .body-md {
          line-height: 1.5 !important;
        }
      }

      @media (max-width: 440px) {
        .hero-text .body-lg {
          font-size: 15.5px !important;
          line-height: 1.55 !important;
        }

        .hero-support-tag {
          font-size: 12.8px !important;
          line-height: 1.32 !important;
        }

        .product-compare-body {
          grid-template-columns: 1fr;
          text-align: center;
        }

        .product-compare-image {
          min-height: 205px;
        }

        .product-compare-image img {
          width: min(82%, 230px);
          max-height: 220px;
        }

        .product-compare-copy {
          text-align: center;
        }

        .product-compare-copy p {
          margin-left: auto;
          margin-right: auto;
        }

        .product-compare-copy .btn {
          margin-left: auto;
          margin-right: auto;
        }
      }
    `));
}
/* =========================================================
   HERO — text left, two sticks right
   ========================================================= */
function Hero() {
    useEffect(() => {
        const cl = document.querySelector('#solia-home-root .hero-stick-cl');
        const pog = document.querySelector('#solia-home-root .hero-stick-pog');
        if (!cl || !pog)
            return undefined;
        let raf = 0;
        const update = () => {
            raf = 0;
            const scrollDrift = clamp(window.scrollY * 0.15, 0, 80);
            cl.style.setProperty('--solia-scroll-y', `${scrollDrift}px`);
            pog.style.setProperty('--solia-scroll-y', `${scrollDrift * 0.85}px`);
        };
        const onScroll = () => {
            if (!raf)
                raf = requestAnimationFrame(update);
        };
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            if (raf)
                cancelAnimationFrame(raf);
        };
    }, []);
    const supportTags = [
        { h: 'Hydration', t: 'electrolytes + coconut water' },
        { h: 'Digestion', t: 'prebiotic fiber + magnesium' },
        { h: 'Muscle-supporting nutrition', t: 'creatine + amino acids' },
        { h: 'Skin health', t: 'hydrolyzed collagen + vitamin C' },
        { h: 'Energy metabolism', t: 'B1 + B6 + B12' },
        { h: 'Micronutrient coverage', t: 'vitamin C + D3 + zinc' }
    ];
    return (React.createElement("section", { className: "hero" },
        React.createElement(HomepageStylePatch, null),
        React.createElement("div", { className: "hero-bg-a" }),
        React.createElement("div", { className: "hero-bg-b" }),
        React.createElement("div", { className: "hero-grid" },
            React.createElement("div", { className: "hero-text rev in" },
                React.createElement("div", { className: "eyebrow", style: { marginBottom: 24 } }, "Daily support for GLP-1 & peptide weight-loss routines."),
                React.createElement("h1", { className: "h1" },
                    "Don\u2019t lose yourself",
                    React.createElement("br", null),
                    "trying to lose ",
                    React.createElement("strong", null, "weight.")),
                React.createElement("p", { className: "body-lg", style: { marginTop: 28, maxWidth: 620, fontSize: 18 } },
                    "Your appetite changed. Your body\u2019s needs didn\u2019t. ",
                    React.createElement("strong", { style: { color: 'var(--black)', fontWeight: 500 } }, "Companion Complex\u2122"),
                    " is a clinician-formulated, once-daily drink mix built to help cover the six things smaller meals can leave short \u2014 hydration, digestion, muscle-supporting nutrition, skin health, energy metabolism, and daily micronutrients.*"),
                React.createElement("div", { className: "hero-support-heading" }, "Supports*"),
                React.createElement("div", { className: "hero-support-grid" }, supportTags.map((tag) => (React.createElement("div", { key: tag.h, className: "hero-support-tag" },
                    React.createElement("span", { className: "hero-check-icon" },
                        React.createElement(CheckIcon, null)),
                    React.createElement("span", null,
                        React.createElement("strong", null, tag.h),
                        " \u2014 ",
                        tag.t))))),
                React.createElement("div", { className: "hero-ctas" },
                    React.createElement("a", { href: L.shop, className: "btn btn-primary" }, "Shop Companion Complex\u2122"),
                    React.createElement("a", { href: L.science, className: "btn btn-ghost" }, "Learn the science \u2192"))),
            React.createElement("div", { className: "hero-stage rev in d1" },
                React.createElement("div", { className: "hero-stage-orb" }),
                React.createElement("div", { className: "hero-stage-ring" }),
                React.createElement("div", { className: "hero-stick hero-stick-cl" },
                    React.createElement("img", { src: window.SOLIA_ASSETS.stickCl, alt: "Coconut Lime stick", width: "631", height: "1844", loading: "eager", fetchPriority: "high", decoding: "async" })),
                React.createElement("div", { className: "hero-stick hero-stick-pog" },
                    React.createElement("img", { src: window.SOLIA_ASSETS.stickPog, alt: "Passion Orange Guava stick", width: "900", height: "1716", loading: "eager", fetchPriority: "high", decoding: "async" })))),
        React.createElement("a", { href: "#flavors", className: "scroll-hint" }, "Discover")));
}
/* =========================================================
   TICKER / BANNER
   Overrides shared Marquee with homepage-specific items.
   ========================================================= */
function Marquee() {
    const items = [
        '30 sticks per bag',
        'Clinician-formulated',
        'Daily nutrition support',
        'Gluten free',
        'Made in USA',
        'Electrolytes',
        'Prebiotic fiber',
        'Creatine',
        'Collagen peptides',
        'Amino acids',
        'No artificial sweeteners',
        'Zero sugar',
        'GMP Certified'
    ];
    const repeated = [...items, ...items];
    return (React.createElement("div", { className: "marquee" },
        React.createElement("div", { className: "marquee-track solia-home-marquee-track" }, repeated.map((it, i) => (React.createElement(React.Fragment, { key: i },
            React.createElement("span", { className: "marquee-item solia-home-marquee-item" }, it),
            React.createElement("span", { className: "marquee-dot solia-home-marquee-dot" }, "\u25C6")))))));
}
/* =========================================================
   STORY — intentionally hidden for now.
   Keeping the component so homepage templates that call it do not break.
   ========================================================= */
function StoryScroll() {
    return null;
}
/* =========================================================
   COMPACT PRODUCT CHOOSER — rendered inside Anatomy so it appears
   above the six support pillars without editing the Liquid section order.
   ========================================================= */
const FLAVORS = [
    {
        id: 'cl',
        number: '01',
        name: 'Coconut Lime',
        desc: 'Clean, crisp, and easy to sip — the everyday flavor you reach for without thinking.',
        img: window.SOLIA_ASSETS.bagCl,
        accent: '#B3CFDA',
        accentBar: '#7AAAB9',
        href: L.coconutLime,
        cta: 'Shop Coconut Lime'
    },
    {
        id: 'pog',
        number: '02',
        name: 'Passion Orange Guava',
        desc: 'Bright, tropical, and smooth — the morning flavor that feels like a treat without the sugar.',
        img: window.SOLIA_ASSETS.bagPog,
        accent: '#F2A65A',
        accentBar: '#F2A65A',
        href: L.pog,
        cta: 'Shop Passion Orange Guava'
    }
];
function ProductChooser() {
    useReveal();
    const facts = [
        '30 single-use sticks',
        'Subscribe & save 15%',
        'Free shipping'
    ];
    return (React.createElement("section", { id: "flavors", className: "home-products" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "home-products-head rev in" },
                React.createElement("div", { className: "eyebrow", style: { marginBottom: 18 } }, "Companion Complex\u2122"),
                React.createElement("h2", { className: "h2", style: { marginBottom: 0 } },
                    "Choose your",
                    React.createElement("br", null),
                    React.createElement("strong", null, "daily companion.")),
                React.createElement("p", { className: "body-md" }, "Two flavors. One formula. Every pillar, every day.")),
            React.createElement("div", { className: "product-compare-grid" }, FLAVORS.map((f) => (React.createElement("article", { key: f.id, className: "product-compare-card rev in d1", style: { '--accent': f.accent, '--accent-bar': f.accentBar } },
                React.createElement("div", { className: "product-compare-top" },
                    React.createElement("div", { className: "product-compare-pill" },
                        React.createElement("span", { className: "dot" }),
                        f.name),
                    React.createElement("div", { className: "product-compare-meta" },
                        "Flavor ",
                        f.number,
                        " of 02")),
                React.createElement("div", { className: "product-compare-body" },
                    React.createElement("a", { href: f.href, className: "product-compare-image", "aria-label": f.name },
                        React.createElement("img", { src: f.img, alt: f.name, loading: "lazy", decoding: "async" })),
                    React.createElement("div", { className: "product-compare-copy" },
                        React.createElement("h3", null, f.name),
                        React.createElement("p", null, f.desc),
                        React.createElement("div", { className: "product-compare-facts" }, facts.map((item) => (React.createElement("span", { key: item, className: "product-compare-fact" },
                            React.createElement("svg", { viewBox: "0 0 12 12", fill: "none" },
                                React.createElement("path", { d: "M2 6.2 L4.8 9 L10 3.2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
                            item)))),
                        React.createElement("a", { href: f.href, className: "btn btn-primary" }, f.cta))))))),
            React.createElement("p", { className: "product-support-line rev in d2" }, "30 single-use sticks \u00B7 Subscribe & save 15% \u00B7 Free shipping"))));
}
/* =========================================================
   FLAVOR SWITCHER — hidden because product chooser now renders above pillars.
   Keeping the component so homepage templates that call it do not break.
   ========================================================= */
function FlavorSwitcher() {
    return null;
}
/* =========================================================
   ANATOMY — SIX SUPPORT PILLARS
   Also renders ProductChooser first so the product cards appear above this.
   ========================================================= */
const ANATOMY_INGREDIENTS = [
    { id: 'hydration', name: 'Hydration + Fluid Balance', sub: 'Electrolytes + coconut water', side: 'left', pos: { top: '12%', left: '50%' } },
    { id: 'digestion', name: 'Digestive Regularity', sub: 'Prebiotic fiber + magnesium', side: 'left', pos: { top: '58%', left: '53%' } },
    { id: 'muscle', name: 'Muscle Support', sub: 'Creatine + targeted amino acids', side: 'left', pos: { top: '50%', left: '41%' } },
    { id: 'skin', name: 'Skin Health', sub: 'Hydrolyzed collagen + vitamin C', side: 'right', pos: { top: '80%', left: '60%' } },
    { id: 'energy', name: 'Energy Metabolism', sub: 'B1, B6, B12', side: 'right', pos: { top: '64%', left: '49%' } },
    { id: 'micronutrients', name: 'Micronutrient Coverage', sub: 'Vitamin C + vitamin D3 + zinc', side: 'right', pos: { top: '32%', left: '55%' } }
];
function Anatomy() {
    useReveal();
    const [active, setActive] = useState('hydration');
    const [hovering, setHovering] = useState(false);
    useEffect(() => {
        if (hovering)
            return;
        const iv = setInterval(() => {
            setActive((prev) => {
                const idx = ANATOMY_INGREDIENTS.findIndex((x) => x.id === prev);
                return ANATOMY_INGREDIENTS[(idx + 1) % ANATOMY_INGREDIENTS.length].id;
            });
        }, 2600);
        return () => clearInterval(iv);
    }, [hovering]);
    const cur = ANATOMY_INGREDIENTS.find((x) => x.id === active) || ANATOMY_INGREDIENTS[0];
    const leftItems = ANATOMY_INGREDIENTS.filter((x) => x.side === 'left');
    const rightItems = ANATOMY_INGREDIENTS.filter((x) => x.side === 'right');
    return (React.createElement(React.Fragment, null,
        React.createElement(ProductChooser, null),
        React.createElement("section", { id: "science", className: "section section-cream section-anatomy home-pillars-compact" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "rev anatomy-head", style: { textAlign: 'center', maxWidth: 880, margin: '0 auto' } },
                    React.createElement("div", { className: "eyebrow", style: { marginBottom: 18 } }, "What one stick covers"),
                    React.createElement("h2", { className: "h2", style: { marginBottom: 20 } },
                        "Six support pillars.",
                        React.createElement("br", null),
                        React.createElement("strong", null, "One complete system.")),
                    React.createElement("p", { className: "body-md", style: { maxWidth: 660, margin: '0 auto' } }, "When appetite is lower, your daily needs don\u2019t shrink with it. Solia maps six ingredient systems to the six areas smaller meals are most likely to leave short \u2014 so one stick covers what a shelf of separate products used to.")),
                React.createElement("div", { className: "anatomy-grid rev", style: { marginTop: 18 } },
                    React.createElement("div", { className: "anatomy-list left" }, leftItems.map((ing) => (React.createElement("div", { key: ing.id, className: `anatomy-item ${active === ing.id ? 'active' : ''}`, onMouseEnter: () => { setActive(ing.id); setHovering(true); }, onMouseLeave: () => setHovering(false) },
                        React.createElement("div", { className: "anatomy-name" }, ing.name),
                        React.createElement("div", { className: "anatomy-sub" }, ing.sub))))),
                    React.createElement("div", { className: "anatomy-figure" },
                        React.createElement("div", { className: "anatomy-figure-inner" },
                            React.createElement("img", { src: window.SOLIA_ASSETS.anatomy, alt: "Human anatomy", width: "436", height: "263", loading: "lazy", decoding: "async" }),
                            React.createElement("div", { className: "anatomy-pulse on", style: { top: cur.pos.top, left: cur.pos.left } }))),
                    React.createElement("div", { className: "anatomy-list right" }, rightItems.map((ing) => (React.createElement("div", { key: ing.id, className: `anatomy-item ${active === ing.id ? 'active' : ''}`, onMouseEnter: () => { setActive(ing.id); setHovering(true); }, onMouseLeave: () => setHovering(false) },
                        React.createElement("div", { className: "anatomy-name" }, ing.name),
                        React.createElement("div", { className: "anatomy-sub" }, ing.sub)))))),
                React.createElement("div", { className: "rev d2", style: { textAlign: 'center', marginTop: 24 } },
                    React.createElement("p", { style: { fontSize: 15, fontStyle: 'italic', color: 'var(--blue-deep)', fontWeight: 500 } }, "One stick. Every gap, covered."))))));
}
/* =========================================================
   REVIEWS — intentionally removed until real reviews are ready.
   Keeping the component so homepage templates that call it do not break.
   ========================================================= */
function Reviews() {
    return null;
}
/* =========================================================
   FINAL CTA
   ========================================================= */
function FinalCTA() {
    useReveal();
    return (React.createElement("section", { id: "shop", className: "cta-block" },
        React.createElement("div", { className: "cta-block-inner" },
            React.createElement("div", { className: "cta-block-logo rev" },
                React.createElement(Logo, { cream: true, height: 56, style: { margin: '0 auto' } })),
            React.createElement("h2", { className: "h2 rev d1", style: {
                    color: 'var(--cream)',
                    marginBottom: 24,
                    fontSize: 'clamp(40px, 5.5vw, 72px)'
                } },
                "The decision was hard.",
                React.createElement("br", null),
                React.createElement("strong", null, "The support shouldn\u2019t be.")),
            React.createElement("p", { className: "body-lg rev d2", style: { maxWidth: 520, margin: '0 auto 44px', color: 'rgba(253,254,241,0.65)' } }, "You already made the hard decision to start. Solia makes sure your body has what it needs to stay the course."),
            React.createElement("div", { className: "rev d3", style: { display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' } },
                React.createElement("a", { href: L.shop, className: "btn btn-cream" }, "Shop Companion Complex\u2122"),
                React.createElement("a", { href: L.shop, className: "btn", style: {
                        color: 'rgba(253,254,241,0.75)',
                        border: '1px solid rgba(253,254,241,0.18)'
                    } }, "Subscribe & save 15%")),
            React.createElement("p", { className: "rev d4", style: {
                    marginTop: 36,
                    fontSize: 12,
                    letterSpacing: 1.2,
                    textTransform: 'uppercase',
                    color: 'rgba(253,254,241,0.30)'
                } }, "Third-party tested \u00B7 cGMP \u00B7 Zero sugar \u00B7 Transparent label \u00B7 Every active ingredient named"),
            React.createElement("p", { className: "rev d5", style: {
                    marginTop: 44,
                    fontSize: 13,
                    fontStyle: 'italic',
                    color: 'rgba(253,254,241,0.40)'
                } }, "Support, by the sip.\u2122"))));
}
Object.assign(window, {
    Hero,
    Marquee,
    StoryScroll,
    Anatomy,
    FlavorSwitcher,
    Reviews,
    FinalCTA
});
